import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 50%;
  box-shadow: 2px 6px 24px rgba(16, 40, 68, 0.2);
  max-height: 90%;
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
  border-radius: 8px;

  @media screen and (max-width: 1280px) {
    width: 90%;
  }
`;

export const ModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;

  @media screen and (max-width: 1280px) {
    max-height: 400px;
  }
`;

export const TopText = styled.p`
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
  color: #09091a;
  border-bottom: 1px solid #f4f4f4;
  padding: 20px 20px 20px 24px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f4f4f4;
`;

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 20px 24px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding: 16px;
  }
`;

export const Image = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 40px;
`;

export const ImageDefault = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  filter: blur(1px);
  background-color: #e9eaf8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageName = styled.p`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -1px;
  color: #09091a;
  text-transform: uppercase;
`;

export const ImageWrapper = styled.div`
  width: 64px;
  max-width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 40px;
  position: relative;
  cursor: pointer;

  @media screen and (max-width: 600px) {
    margin-bottom: 16px;
  }
`;

export const ImagePlace = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
`;

export const EditIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ImageEmpty = styled.div`
  width: 75px;
  height: 64px;
  border-radius: 50%;
  margin-right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9eaf8;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 600px) {
    margin-bottom: 16px;
  }
`;

export const AddPhoto = styled.input`
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
  z-index: 1;
  position: absolute;
  cursor: pointer;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputField = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const InputFieldHalf = styled.div`
  width: 49%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const InputDiv = styled.div`
  height: 41px;
  border: 1px solid #c6c7da;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 4px;
`;

export const InputLabel = styled.label`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 8px;
`;

export const FieldIcon = styled.div`
  position: absolute;
  top: 72%;
  transform: translateY(-65%);
  right: 0;
  padding: 10px;
`;

export const SelectedValue = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-30%);
  left: 0;
  padding: 8px 16px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #c6c7da;
  min-height: 41px;
`;

export const Select = styled.select`
  border: 1px solid #c6c7da;
  border-radius: 4px;
  outline: none;
  padding: 6px 16px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: transparent;
  opacity: 0;
`;

export const Opt = styled.option`
  border: 1px solid #c6c7da;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
`;

export const Input = styled.input`
  width: 100%;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 8px;
  border: 1px solid #c6c7da;
  padding: 10px;
  outline: none;
  color: #09091a;
  margin-bottom: 12px;
  border-radius: 4px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const TextArea = styled.textarea`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 8px;
  border: 1px solid #c6c7da;
  padding: 10px;
  outline: none;
  font-size: 16px;
  color: #09091a;
  margin-bottom: 12px;
  max-width: 100%;
  max-height: 60px;
`;

export const Required = styled.span`
  color: #9292a4;
`;

export const Block = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #f4f4f4;
`;

export const ShowAddButton = styled.button`
  color: #616172;
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: 20px;

  @media screen and (max-width: 520px) {
    margin-left: 0;
    margin-right: 16px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Cancel = styled.button`
  color: #616172;
  font-family: 'MontserratSemiBold';
  font-weight: 600;
  font-size: 16px;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  margin-right: 40px;
`;

export const Error = styled.span`
  position: absolute;
  bottom: -5px;
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 12px;
  color: #f30f00;
`;
